// extracted by mini-css-extract-plugin
export var compactFilters = "_d5-4";
export var detailImage = "_d5-1";
export var dropdownContainer = "_d5-2";
export var imageContainer = "_d5-0";
export var selectedCard = "_d5-3";